// extracted by mini-css-extract-plugin
module.exports = {"back":"BackLink_back__2l5i9","link":"BackLink_link__3IfhH","backButton":"BackLink_backButton__2s1Qr"};